exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2VYYpzegnx37BKJZYehwRS{\n    padding-left: var(--page-padding);\n    padding-right: var(--page-padding);\n}\n\n._2VYYpzegnx37BKJZYehwRS .carousel-indicators {\n    bottom: -32px;\n}\n\n._2VYYpzegnx37BKJZYehwRS .carousel-indicators > li {\n    border: #D9D9D9 solid 2px;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n}\n\n._2VYYpzegnx37BKJZYehwRS .carousel-indicators > li.active {\n    background-color: #D9D9D9;\n}\n\n._2VYYpzegnx37BKJZYehwRS .carousel-control {\n    display: none;\n}\n", ""]);

// exports
exports.locals = {
	"root": "_2VYYpzegnx37BKJZYehwRS"
};